/**
 * SGKC007A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TankatableregistrationManageInfo {

    /**
     * 単価表登録管理通番
     */
    tankatableregistrationManagementserialnumber?: string;
    /**
     * 単価表コード履歴番号
     */
    tankahyocodeRrkno?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
    /**
     * 適用終了日付
     */
    applyEndDate?: string;
    /**
     * 承認ステータスコード
     */
    apprvStatuscode?: string;
    /**
     * 承認ステータス
     */
    approvalstatus?: string;
    /**
     * 登録者名
     */
    registrantname?: string;
    /**
     * 登録部署名
     */
    regDepartmentname?: string;
    /**
     * 登録日付
     */
    regDate?: string;
    /**
     * 登録時刻
     */
    registrationtime?: string;
    /**
     * 承認者名
     */
    approvername?: string;
    /**
     * 承認部署名
     */
    apprvDepartmentname?: string;
    /**
     * 承認日付
     */
    apprvDate?: string;
    /**
     * 承認時刻
     */
    apprvHms?: string;
}

